/* 
 * @Author: 曹俊杰 
 * @Date: 2023-04-22 22:11:44
 * @Module: 案件权益表单
 */
 <template>
  <el-dialog :title="type=='add'?'添加案件权益':type=='revision'?'修改案件权益':''" :visible.sync="dialogVisible" width="800px" @closed="closed">
    <div style="padding:20px;">
      <el-form size="mini" label-position="top" :model="form" ref="form">
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item label="权益名称" prop="item">
              <el-input v-model="form.item" placeholder="请输入权益名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金额" prop="amount">
              <el-input v-model.number="form.amount" placeholder="请输入金额"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="mini">取 消</el-button>
      <el-button type="primary" @click="submit" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</template>
 <script>
export default {

  data () {

    return {
      type: 'add',
      dialogVisible: false,
      form: {
        item: '',
        amount: '',
      }
    };
  },
  mounted () { },
  methods: {
    show ({ type = 'add', data }) {
      if (type == "revision") {
        this.form = this.$utils.deepClone(data);
      } else if (type == "add") {
        this.lawsuitUuid = data.uuid
      }
      this.type = type
      this.dialogVisible = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.postLawsuitEquity()
        } else {
          return false
        }
      })
    },
    close () {
      this.dialogVisible = false
    },
    closed () {
      this.form = {
        item: '',
        amount: '',
      }
    },
    async postLawsuitEquity () {
      const api = {
        revision: {
          func: this.$api.putChangeLawsuitEquity,
          params: {
            ...this.form
          }
        },
        add: {
          func: this.$api.postLawsuitEquity,
          params: {
            ...this.form,
            lawsuitUuid: this.lawsuitUuid
          }
        }
      }

      const { status, data, info } = await api[this.type].func(api[this.type].params)
      if (status === 200) {
        this.$message({
          type: 'success',
          message: info
        })
        this.$emit('success', this.type)
        this.dialogVisible = false;
      } else {
        this.$message({
          type: 'error',
          message: info
        })
      }
    },
  },
};
 </script>
 <style lang='scss' scoped>
</style>